import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDeletionModal from '__components/Modals/presets/ConfirmDeletion';

type DeleteServerModalProps = {
  server: { id: string; name: string };
  onConfirm: () => Promise<void>;
  onHide: () => void;
};

export const DeleteServerModal: FC<DeleteServerModalProps> = ({
  onConfirm,
  onHide,
}) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = useCallback(async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setSubmitting(false);
    }
  }, [submitting, onConfirm]);

  return (
    <ConfirmDeletionModal
      show
      disabled={submitting}
      onConfirm={handleConfirm}
      onHide={onHide}
    >
      {t(
        'This will permanently delete this MCP server and revoke access for anyone connecting through it.'
      )}
    </ConfirmDeletionModal>
  );
};
